"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapMenuBanners = function mapMenuBanners(response) {
  var _response$data, _response$data$body;
  if (!response) return false;
  return (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.map(function (banner) {
    var _banner$primary$title, _banner$primary$subti, _banner$primary$url;
    return {
      categoryId: banner.primary.categoryid,
      image: banner.primary.image && (0, _image["default"])(banner.primary.image),
      title: (_banner$primary$title = banner.primary.title[0]) === null || _banner$primary$title === void 0 ? void 0 : _banner$primary$title.text,
      subtitle: (_banner$primary$subti = banner.primary.subtitle[0]) === null || _banner$primary$subti === void 0 ? void 0 : _banner$primary$subti.text,
      url: (_banner$primary$url = banner.primary.url) !== null && _banner$primary$url !== void 0 && _banner$primary$url.url ? banner.primary.url.url.replace("https:/", "") : "/"
    };
  });
};
var _default = mapMenuBanners;
exports["default"] = _default;